import React from "react";
export const administration = () => {
  return (
    <div className="opinion-wrap">
      <h1>中华人民共和国行政许可法</h1>
      <div className="text-cont">
         
        <br />
        <br />
        第一章　总　　则 　　 <br />
        <br />
        第一条　为了规范行政许可的设定和实施，保护公民、法人和其他组织的合法权益，维护公共利益和社会秩序，保障和监督行政机关有效实施行政管理，根据宪法，制定本法。
        　　 <br />
        <br />
        第二条　本法所称行政许可，是指行政机关根据公民、法人或者其他组织的申请，经依法审查，准予其从事特定活动的行为。
        　　 <br />
        <br />
        第三条　行政许可的设定和实施，适用本法。
        　　有关行政机关对其他机关或者对其直接管理的事业单位的人事、财务、外事等事项的审批，不适用本法。
        　　 <br />
        <br />
        第四条　设定和实施行政许可，应当依照法定的权限、范围、条件和程序。 　　{" "}
        <br />
        <br />
        第五条　设定和实施行政许可，应当遵循公开、公平、公正、非歧视的原则。
        　　有关行政许可的规定应当公布；未经公布的，不得作为实施行政许可的依据。行政许可的实施和结果，除涉及国家秘密、商业秘密或者个人隐私的外，应当公开。未经申请人同意，行政机关及其工作人员、参与专家评审等的人员不得披露申请人提交的商业秘密、未披露信息或者保密商务信息，法律另有规定或者涉及国家安全、重大社会公共利益的除外；行政机关依法公开申请人前述信息的，允许申请人在合理期限内提出异议。
        　　符合法定条件、标准的，申请人有依法取得行政许可的平等权利，行政机关不得歧视任何人。
        　　 <br />
        <br />
        第六条　实施行政许可，应当遵循便民的原则，提高办事效率，提供优质服务。
        　　 <br />
        <br />
        第七条　公民、法人或者其他组织对行政机关实施行政许可，享有陈述权、申辩权；有权依法申请行政复议或者提起行政诉讼；其合法权益因行政机关违法实施行政许可受到损害的，有权依法要求赔偿。
        　　 <br />
        <br />
        第八条　公民、法人或者其他组织依法取得的行政许可受法律保护，行政机关不得擅自改变已经生效的行政许可。
        　　行政许可所依据的法律、法规、规章修改或者废止，或者准予行政许可所依据的客观情况发生重大变化的，为了公共利益的需要，行政机关可以依法变更或者撤回已经生效的行政许可。由此给公民、法人或者其他组织造成财产损失的，行政机关应当依法给予补偿。
        　　 <br />
        <br />
        第九条　依法取得的行政许可，除法律、法规规定依照法定条件和程序可以转让的外，不得转让。
        　　 <br />
        <br />
        第十条　县级以上人民政府应当建立健全对行政机关实施行政许可的监督制度，加强对行政机关实施行政许可的监督检查。
        　　行政机关应当对公民、法人或者其他组织从事行政许可事项的活动实施有效监督。
        <br />
        <br />
        第二章　行政许可的设定 　　 <br />
        <br />
        第十一条　设定行政许可，应当遵循经济和社会发展规律，有利于发挥公民、法人或者其他组织的积极性、主动性，维护公共利益和社会秩序，促进经济、社会和生态环境协调发展。
        　　 <br />
        <br />
        第十二条　下列事项可以设定行政许可： 　　 <br />
        <br />
        （一）直接涉及国家安全、公共安全、经济宏观调控、生态环境保护以及直接关系人身健康、生命财产安全等特定活动，需要按照法定条件予以批准的事项；
        　　 <br />
        <br />
        （二）有限自然资源开发利用、公共资源配置以及直接关系公共利益的特定行业的市场准入等，需要赋予特定权利的事项；
        　　 <br />
        <br />
        （三）提供公众服务并且直接关系公共利益的职业、行业，需要确定具备特殊信誉、特殊条件或者特殊技能等资格、资质的事项；
        　　 <br />
        <br />
        （四）直接关系公共安全、人身健康、生命财产安全的重要设备、设施、产品、物品，需要按照技术标准、技术规范，通过检验、检测、检疫等方式进行审定的事项；
        　　 <br />
        <br />
        （五）企业或者其他组织的设立等，需要确定主体资格的事项； 　　 <br />
        <br />
        （六）法律、行政法规规定可以设定行政许可的其他事项。 　　 <br />
        <br />
        第十三条　本法 
        第十二条所列事项，通过下列方式能够予以规范的，可以不设行政许可： 　　{" "}
        <br />
        <br />
        （一）公民、法人或者其他组织能够自主决定的； 　　 <br />
        <br />
        （二）市场竞争机制能够有效调节的； 　　 <br />
        <br />
        （三）行业组织或者中介机构能够自律管理的； 　　 <br />
        <br />
        （四）行政机关采用事后监督等其他行政管理方式能够解决的。 　　 <br />
        <br />
        第十四条　本法 
        第十二条所列事项，法律可以设定行政许可。尚未制定法律的，行政法规可以设定行政许可。
        　　必要时，国务院可以采用发布决定的方式设定行政许可。实施后，除临时性行政许可事项外，国务院应当及时提请全国人民代表大会及其常务委员会制定法律，或者自行制定行政法规。
        　　 <br />
        <br />
        第十五条　本法 
        第十二条所列事项，尚未制定法律、行政法规的，地方性法规可以设定行政许可；尚未制定法律、行政法规和地方性法规的，因行政管理的需要，确需立即实施行政许可的，省、自治区、直辖市人民政府规章可以设定临时性的行政许可。临时性的行政许可实施满一年需要继续实施的，应当提请本级人民代表大会及其常务委员会制定地方性法规。
        　　地方性法规和省、自治区、直辖市人民政府规章，不得设定应当由国家统一确定的公民、法人或者其他组织的资格、资质的行政许可；不得设定企业或者其他组织的设立登记及其前置性行政许可。其设定的行政许可，不得限制其他地区的个人或者企业到本地区从事生产经营和提供服务，不得限制其他地区的商品进入本地区市场。
        　　 <br />
        <br />
        第十六条　行政法规可以在法律设定的行政许可事项范围内，对实施该行政许可作出具体规定。
        　　地方性法规可以在法律、行政法规设定的行政许可事项范围内，对实施该行政许可作出具体规定。
        　　规章可以在上位法设定的行政许可事项范围内，对实施该行政许可作出具体规定。
        　　法规、规章对实施上位法设定的行政许可作出的具体规定，不得增设行政许可；对行政许可条件作出的具体规定，不得增设违反上位法的其他条件。
        　　 <br />
        <br />
        第十七条　除本法 
        第十四条、
        第十五条规定的外，其他规范性文件一律不得设定行政许可。 　　 <br />
        <br />
        第十八条　设定行政许可，应当规定行政许可的实施机关、条件、程序、期限。
        　　 <br />
        <br />
        第十九条　起草法律草案、法规草案和省、自治区、直辖市人民政府规章草案，拟设定行政许可的，起草单位应当采取听证会、论证会等形式听取意见，并向制定机关说明设定该行政许可的必要性、对经济和社会可能产生的影响以及听取和采纳意见的情况。
        　　 <br />
        <br />
        第二十条　行政许可的设定机关应当定期对其设定的行政许可进行评价；对已设定的行政许可，认为通过本法{" "}
        第十三条所列方式能够解决的，应当对设定该行政许可的规定及时予以修改或者废止。
        　　行政许可的实施机关可以对已设定的行政许可的实施情况及存在的必要性适时进行评价，并将意见报告该行政许可的设定机关。
        　　公民、法人或者其他组织可以向行政许可的设定机关和实施机关就行政许可的设定和实施提出意见和建议。
        　　 <br />
        <br />
        第二十一条　省、自治区、直辖市人民政府对行政法规设定的有关经济事务的行政许可，根据本行政区域经济和社会发展情况，认为通过本法{" "}
        <br />
        <br />
        第十三条所列方式能够解决的，报国务院批准后，可以在本行政区域内停止实施该行政许可。
        <br />
        <br />
        第三章　行政许可的实施机关 　　 <br />
        <br />
        第二十二条　行政许可由具有行政许可权的行政机关在其法定职权范围内实施。
        　　 <br />
        <br />
        第二十三条　法律、法规授权的具有管理公共事务职能的组织，在法定授权范围内，以自己的名义实施行政许可。被授权的组织适用本法有关行政机关的规定。
        　　 <br />
        <br />
        第二十四条　行政机关在其法定职权范围内，依照法律、法规、规章的规定，可以委托其他行政机关实施行政许可。委托机关应当将受委托行政机关和受委托实施行政许可的内容予以公告。
        　　委托行政机关对受委托行政机关实施行政许可的行为应当负责监督，并对该行为的后果承担法律责任。
        　　受委托行政机关在委托范围内，以委托行政机关名义实施行政许可；不得再委托其他组织或者个人实施行政许可。
        　　 <br />
        <br />
        第二十五条　经国务院批准，省、自治区、直辖市人民政府根据精简、统一、效能的原则，可以决定一个行政机关行使有关行政机关的行政许可权。
        　　 <br />
        <br />
        第二十六条　行政许可需要行政机关内设的多个机构办理的，该行政机关应当确定一个机构统一受理行政许可申请，统一送达行政许可决定。
        　　行政许可依法由地方人民政府两个以上部门分别实施的，本级人民政府可以确定一个部门受理行政许可申请并转告有关部门分别提出意见后统一办理，或者组织有关部门联合办理、集中办理。
        　　 <br />
        <br />
        第二十七条　行政机关实施行政许可，不得向申请人提出购买指定商品、接受有偿服务等不正当要求。
        　　行政机关工作人员办理行政许可，不得索取或者收受申请人的财物，不得谋取其他利益。
        　　 <br />
        <br />
        第二十八条　对直接关系公共安全、人身健康、生命财产安全的设备、设施、产品、物品的检验、检测、检疫，除法律、行政法规规定由行政机关实施的外，应当逐步由符合法定条件的专业技术组织实施。专业技术组织及其有关人员对所实施的检验、检测、检疫结论承担法律责任。
        <br />
        <br />
        第四章　行政许可的实施程序
        <br />
        <br />
        第一节　申请与受理 　　 <br />
        <br />
        第二十九条　公民、法人或者其他组织从事特定活动，依法需要取得行政许可的，应当向行政机关提出申请。申请书需要采用格式文本的，行政机关应当向申请人提供行政许可申请书格式文本。申请书格式文本中不得包含与申请行政许可事项没有直接关系的内容。
        　　申请人可以委托代理人提出行政许可申请。但是，依法应当由申请人到行政机关办公场所提出行政许可申请的除外。
        　　行政许可申请可以通过信函、电报、电传、传真、电子数据交换和电子邮件等方式提出。
        　　 <br />
        <br />
        第三十条　行政机关应当将法律、法规、规章规定的有关行政许可的事项、依据、条件、数量、程序、期限以及需要提交的全部材料的目录和申请书示范文本等在办公场所公示。
        　　申请人要求行政机关对公示内容予以说明、解释的，行政机关应当说明、解释，提供准确、可靠的信息。
        　　 <br />
        <br />
        第三十一条　申请人申请行政许可，应当如实向行政机关提交有关材料和反映真实情况，并对其申请材料实质内容的真实性负责。行政机关不得要求申请人提交与其申请的行政许可事项无关的技术资料和其他材料。
        　　行政机关及其工作人员不得以转让技术作为取得行政许可的条件；不得在实施行政许可的过程中，直接或者间接地要求转让技术。
        　　 <br />
        <br />
        第三十二条　行政机关对申请人提出的行政许可申请，应当根据下列情况分别作出处理：
        　　 <br />
        <br />
        （一）申请事项依法不需要取得行政许可的，应当即时告知申请人不受理； 　　{" "}
        <br />
        <br />
        （二）申请事项依法不属于本行政机关职权范围的，应当即时作出不予受理的决定，并告知申请人向有关行政机关申请；
        　　 <br />
        <br />
        （三）申请材料存在可以当场更正的错误的，应当允许申请人当场更正； 　　{" "}
        <br />
        <br />
        （四）申请材料不齐全或者不符合法定形式的，应当当场或者在五日内一次告知申请人需要补正的全部内容，逾期不告知的，自收到申请材料之日起即为受理；
        　　 <br />
        <br />
        （五）申请事项属于本行政机关职权范围，申请材料齐全、符合法定形式，或者申请人按照本行政机关的要求提交全部补正申请材料的，应当受理行政许可申请。
        　　行政机关受理或者不予受理行政许可申请，应当出具加盖本行政机关专用印章和注明日期的书面凭证。
        　　 <br />
        <br />
        第三十三条　行政机关应当建立和完善有关制度，推行电子政务，在行政机关的网站上公布行政许可事项，方便申请人采取数据电文等方式提出行政许可申请；应当与其他行政机关共享有关行政许可信息，提高办事效率。
        <br />
        <br />
        第二节　审查与决定 　　 <br />
        <br />
        第三十四条　行政机关应当对申请人提交的申请材料进行审查。
        　　申请人提交的申请材料齐全、符合法定形式，行政机关能够当场作出决定的，应当当场作出书面的行政许可决定。
        　　根据法定条件和程序，需要对申请材料的实质内容进行核实的，行政机关应当指派两名以上工作人员进行核查。
        　　 <br />
        <br />
        第三十五条　依法应当先经下级行政机关审查后报上级行政机关决定的行政许可，下级行政机关应当在法定期限内将初步审查意见和全部申请材料直接报送上级行政机关。上级行政机关不得要求申请人重复提供申请材料。
        　　 <br />
        <br />
        第三十六条　行政机关对行政许可申请进行审查时，发现行政许可事项直接关系他人重大利益的，应当告知该利害关系人。申请人、利害关系人有权进行陈述和申辩。行政机关应当听取申请人、利害关系人的意见。
        　　 <br />
        <br />
        第三十七条　行政机关对行政许可申请进行审查后，除当场作出行政许可决定的外，应当在法定期限内按照规定程序作出行政许可决定。
        　　 <br />
        <br />
        第三十八条　申请人的申请符合法定条件、标准的，行政机关应当依法作出准予行政许可的书面决定。
        　　行政机关依法作出不予行政许可的书面决定的，应当说明理由，并告知申请人享有依法申请行政复议或者提起行政诉讼的权利。
        　　 <br />
        <br />
        第三十九条　行政机关作出准予行政许可的决定，需要颁发行政许可证件的，应当向申请人颁发加盖本行政机关印章的下列行政许可证件：
        　　 <br />
        <br />
        （一）许可证、执照或者其他许可证书； 　　 <br />
        <br />
        （二）资格证、资质证或者其他合格证书； 　　 <br />
        <br />
        （三）行政机关的批准文件或者证明文件； 　　 <br />
        <br />
        （四）法律、法规规定的其他行政许可证件。
        　　行政机关实施检验、检测、检疫的，可以在检验、检测、检疫合格的设备、设施、产品、物品上加贴标签或者加盖检验、检测、检疫印章。
        　　 <br />
        <br />
        第四十条　行政机关作出的准予行政许可决定，应当予以公开，公众有权查阅。
        　　 <br />
        <br />
        第四十一条　法律、行政法规设定的行政许可，其适用范围没有地域限制的，申请人取得的行政许可在全国范围内有效。
        <br />
        <br />
        第三节　期　　限 　　 <br />
        <br />
        第四十二条　除可以当场作出行政许可决定的外，行政机关应当自受理行政许可申请之日起二十日内作出行政许可决定。二十日内不能作出决定的，经本行政机关负责人批准，可以延长十日，并应当将延长期限的理由告知申请人。但是，法律、法规另有规定的，依照其规定。
        　　依照本法
        第二十六条的规定，行政许可采取统一办理或者联合办理、集中办理的，办理的时间不得超过四十五日；四十五日内不能办结的，经本级人民政府负责人批准，可以延长十五日，并应当将延长期限的理由告知申请人。
        　　 <br />
        <br />
        第四十三条　依法应当先经下级行政机关审查后报上级行政机关决定的行政许可，下级行政机关应当自其受理行政许可申请之日起二十日内审查完毕。但是，法律、法规另有规定的，依照其规定。
        　　 <br />
        <br />
        第四十四条　行政机关作出准予行政许可的决定，应当自作出决定之日起十日内向申请人颁发、送达行政许可证件，或者加贴标签、加盖检验、检测、检疫印章。
        　　 <br />
        <br />
        第四十五条　行政机关作出行政许可决定，依法需要听证、招标、拍卖、检验、检测、检疫、鉴定和专家评审的，所需时间不计算在本节规定的期限内。行政机关应当将所需时间书面告知申请人。
        <br />
        <br />
        第四节　听　　证 　　 <br />
        <br />
        第四十六条　法律、法规、规章规定实施行政许可应当听证的事项，或者行政机关认为需要听证的其他涉及公共利益的重大行政许可事项，行政机关应当向社会公告，并举行听证。
        　　 <br />
        <br />
        第四十七条　行政许可直接涉及申请人与他人之间重大利益关系的，行政机关在作出行政许可决定前，应当告知申请人、利害关系人享有要求听证的权利；申请人、利害关系人在被告知听证权利之日起五日内提出听证申请的，行政机关应当在二十日内组织听证。
        　　申请人、利害关系人不承担行政机关组织听证的费用。 　　 <br />
        <br />
        第四十八条　听证按照下列程序进行： 　　 <br />
        <br />
        （一）行政机关应当于举行听证的七日前将举行听证的时间、地点通知申请人、利害关系人，必要时予以公告；
        　　 <br />
        <br />
        （二）听证应当公开举行； 　　 <br />
        <br />
        （三）行政机关应当指定审查该行政许可申请的工作人员以外的人员为听证主持人，申请人、利害关系人认为主持人与该行政许可事项有直接利害关系的，有权申请回避；
        　　 <br />
        <br />
        （四）举行听证时，审查该行政许可申请的工作人员应当提供审查意见的证据、理由，申请人、利害关系人可以提出证据，并进行申辩和质证；
        　　 <br />
        <br />
        （五）听证应当制作笔录，听证笔录应当交听证参加人确认无误后签字或者盖章。
        　　行政机关应当根据听证笔录，作出行政许可决定。
        <br />
        <br />
        第五节　变更与延续 　　 <br />
        <br />
        第四十九条　被许可人要求变更行政许可事项的，应当向作出行政许可决定的行政机关提出申请；符合法定条件、标准的，行政机关应当依法办理变更手续。
        　　 <br />
        <br />
        第五十条　被许可人需要延续依法取得的行政许可的有效期的，应当在该行政许可有效期届满三十日前向作出行政许可决定的行政机关提出申请。但是，法律、法规、规章另有规定的，依照其规定。
        　　行政机关应当根据被许可人的申请，在该行政许可有效期届满前作出是否准予延续的决定；逾期未作决定的，视为准予延续。
        <br />
        <br />
        第六节　特别规定 　　 <br />
        <br />
        第五十一条　实施行政许可的程序，本节有规定的，适用本节规定；本节没有规定的，适用本章其他有关规定。
        　　 <br />
        <br />
        第五十二条　国务院实施行政许可的程序，适用有关法律、行政法规的规定。
        　　 <br />
        <br />
        第五十三条　实施本法 
        第十二条 
        第二项所列事项的行政许可的，行政机关应当通过招标、拍卖等公平竞争的方式作出决定。但是，法律、行政法规另有规定的，依照其规定。
        　　行政机关通过招标、拍卖等方式作出行政许可决定的具体程序，依照有关法律、行政法规的规定。
        　　行政机关按照招标、拍卖程序确定中标人、买受人后，应当作出准予行政许可的决定，并依法向中标人、买受人颁发行政许可证件。
        　　行政机关违反本条规定，不采用招标、拍卖方式，或者违反招标、拍卖程序，损害申请人合法权益的，申请人可以依法申请行政复议或者提起行政诉讼。
        　　 <br />
        <br />
        第五十四条　实施本法 
        第十二条 
        第三项所列事项的行政许可，赋予公民特定资格，依法应当举行国家考试的，行政机关根据考试成绩和其他法定条件作出行政许可决定；赋予法人或者其他组织特定的资格、资质的，行政机关根据申请人的专业人员构成、技术条件、经营业绩和管理水平等的考核结果作出行政许可决定。但是，法律、行政法规另有规定的，依照其规定。
        　　公民特定资格的考试依法由行政机关或者行业组织实施，公开举行。行政机关或者行业组织应当事先公布资格考试的报名条件、报考办法、考试科目以及考试大纲。但是，不得组织强制性的资格考试的考前培训，不得指定教材或者其他助考材料。
        　　 <br />
        <br />
        第五十五条　实施本法
        第十二条 
        第四项所列事项的行政许可的，应当按照技术标准、技术规范依法进行检验、检测、检疫，行政机关根据检验、检测、检疫的结果作出行政许可决定。
        　　行政机关实施检验、检测、检疫，应当自受理申请之日起五日内指派两名以上工作人员按照技术标准、技术规范进行检验、检测、检疫。不需要对检验、检测、检疫结果作进一步技术分析即可认定设备、设施、产品、物品是否符合技术标准、技术规范的，行政机关应当当场作出行政许可决定。
        　　行政机关根据检验、检测、检疫结果，作出不予行政许可决定的，应当书面说明不予行政许可所依据的技术标准、技术规范。
        　　 <br />
        <br />
        第五十六条　实施本法 
        第十二条 
        第五项所列事项的行政许可，申请人提交的申请材料齐全、符合法定形式的，行政机关应当当场予以登记。需要对申请材料的实质内容进行核实的，行政机关依照本法{" "}
      
        第三十四条 
        第三款的规定办理。 　　 <br />
        <br />
        第五十七条　有数量限制的行政许可，两个或者两个以上申请人的申请均符合法定条件、标准的，行政机关应当根据受理行政许可申请的先后顺序作出准予行政许可的决定。但是，法律、行政法规另有规定的，依照其规定。
        <br />
        <br />
        第五章　行政许可的费用 　　 <br />
        <br />
        第五十八条　行政机关实施行政许可和对行政许可事项进行监督检查，不得收取任何费用。但是，法律、行政法规另有规定的，依照其规定。
        　　行政机关提供行政许可申请书格式文本，不得收费。
        　　行政机关实施行政许可所需经费应当列入本行政机关的预算，由本级财政予以保障，按照批准的预算予以核拨。
        　　 <br />
        <br />
        第五十九条　行政机关实施行政许可，依照法律、行政法规收取费用的，应当按照公布的法定项目和标准收费；所收取的费用必须全部上缴国库，任何机关或者个人不得以任何形式截留、挪用、私分或者变相私分。财政部门不得以任何形式向行政机关返还或者变相返还实施行政许可所收取的费用。
        <br />
        <br />
        第六章　监督检查 　　 <br />
        <br />
        第六十条　上级行政机关应当加强对下级行政机关实施行政许可的监督检查，及时纠正行政许可实施中的违法行为。
        　　 <br />
        <br />
        第六十一条　行政机关应当建立健全监督制度，通过核查反映被许可人从事行政许可事项活动情况的有关材料，履行监督责任。
        　　行政机关依法对被许可人从事行政许可事项的活动进行监督检查时，应当将监督检查的情况和处理结果予以记录，由监督检查人员签字后归档。公众有权查阅行政机关监督检查记录。
        　　行政机关应当创造条件，实现与被许可人、其他有关行政机关的计算机档案系统互联，核查被许可人从事行政许可事项活动情况。
        　　 <br />
        <br />
        第六十二条　行政机关可以对被许可人生产经营的产品依法进行抽样检查、检验、检测，对其生产经营场所依法进行实地检查。检查时，行政机关可以依法查阅或者要求被许可人报送有关材料；被许可人应当如实提供有关情况和材料。
        　　行政机关根据法律、行政法规的规定，对直接关系公共安全、人身健康、生命财产安全的重要设备、设施进行定期检验。对检验合格的，行政机关应当发给相应的证明文件。
        　　 <br />
        <br />
        第六十三条　行政机关实施监督检查，不得妨碍被许可人正常的生产经营活动，不得索取或者收受被许可人的财物，不得谋取其他利益。
        　　 <br />
        <br />
        第六十四条　被许可人在作出行政许可决定的行政机关管辖区域外违法从事行政许可事项活动的，违法行为发生地的行政机关应当依法将被许可人的违法事实、处理结果抄告作出行政许可决定的行政机关。
        　　 <br />
        <br />
        第六十五条　个人和组织发现违法从事行政许可事项的活动，有权向行政机关举报，行政机关应当及时核实、处理。
        　　 <br />
        <br />
        第六十六条　被许可人未依法履行开发利用自然资源义务或者未依法履行利用公共资源义务的，行政机关应当责令限期改正；被许可人在规定期限内不改正的，行政机关应当依照有关法律、行政法规的规定予以处理。
        　　 <br />
        <br />
        第六十七条　取得直接关系公共利益的特定行业的市场准入行政许可的被许可人，应当按照国家规定的服务标准、资费标准和行政机关依法规定的条件，向用户提供安全、方便、稳定和价格合理的服务，并履行普遍服务的义务；未经作出行政许可决定的行政机关批准，不得擅自停业、歇业。
        　　被许可人不履行前款规定的义务的，行政机关应当责令限期改正，或者依法采取有效措施督促其履行义务。
        　　 <br />
        <br />
        第六十八条　对直接关系公共安全、人身健康、生命财产安全的重要设备、设施，行政机关应当督促设计、建造、安装和使用单位建立相应的自检制度。
        　　行政机关在监督检查时，发现直接关系公共安全、人身健康、生命财产安全的重要设备、设施存在安全隐患的，应当责令停止建造、安装和使用，并责令设计、建造、安装和使用单位立即改正。
        　　 <br />
        <br />
        第六十九条　有下列情形之一的，作出行政许可决定的行政机关或者其上级行政机关，根据利害关系人的请求或者依据职权，可以撤销行政许可：
        　　 <br />
        <br />
        （一）行政机关工作人员滥用职权、玩忽职守作出准予行政许可决定的； 　　{" "}
        <br />
        <br />
        （二）超越法定职权作出准予行政许可决定的； 　　 <br />
        <br />
        （三）违反法定程序作出准予行政许可决定的； 　　 <br />
        <br />
        （四）对不具备申请资格或者不符合法定条件的申请人准予行政许可的； 　　{" "}
        <br />
        <br />
        （五）依法可以撤销行政许可的其他情形。
        　　被许可人以欺骗、贿赂等不正当手段取得行政许可的，应当予以撤销。
        　　依照前两款的规定撤销行政许可，可能对公共利益造成重大损害的，不予撤销。
        　　依照本条 <br />
        <br />
        第一款的规定撤销行政许可，被许可人的合法权益受到损害的，行政机关应当依法给予赔偿。依照本条{" "}
        <br />
        <br />
        第二款的规定撤销行政许可的，被许可人基于行政许可取得的利益不受保护。
        　　 <br />
        <br />
        第七十条　有下列情形之一的，行政机关应当依法办理有关行政许可的注销手续：
        　　 <br />
        <br />
        （一）行政许可有效期届满未延续的； 　　 <br />
        <br />
        （二）赋予公民特定资格的行政许可，该公民死亡或者丧失行为能力的； 　　{" "}
        <br />
        <br />
        （三）法人或者其他组织依法终止的； 　　 <br />
        <br />
        （四）行政许可依法被撤销、撤回，或者行政许可证件依法被吊销的； 　　{" "}
        <br />
        <br />
        （五）因不可抗力导致行政许可事项无法实施的； 　　 <br />
        <br />
        （六）法律、法规规定的应当注销行政许可的其他情形。
        <br />
        <br />
        第七章　法律责任 　　 <br />
        <br />
        第七十一条　违反本法 <br />
        <br />
        第十七条规定设定的行政许可，有关机关应当责令设定该行政许可的机关改正，或者依法予以撤销。
        　　 <br />
        <br />
        第七十二条　行政机关及其工作人员违反本法的规定，有下列情形之一的，由其上级行政机关或者监察机关责令改正；情节严重的，对直接负责的主管人员和其他直接责任人员依法给予行政处分：
        　　 <br />
        <br />
        （一）对符合法定条件的行政许可申请不予受理的； 　　 <br />
        <br />
        （二）不在办公场所公示依法应当公示的材料的； 　　 <br />
        <br />
        （三）在受理、审查、决定行政许可过程中，未向申请人、利害关系人履行法定告知义务的；
        　　 <br />
        <br />
        （四）申请人提交的申请材料不齐全、不符合法定形式，不一次告知申请人必须补正的全部内容的；
        　　 <br />
        <br />
        （五）违法披露申请人提交的商业秘密、未披露信息或者保密商务信息的； 　　{" "}
        <br />
        <br />
        （六）以转让技术作为取得行政许可的条件，或者在实施行政许可的过程中直接或者间接地要求转让技术的；
        　　 <br />
        <br />
        （七）未依法说明不受理行政许可申请或者不予行政许可的理由的； 　　 <br />
        <br />
        （八）依法应当举行听证而不举行听证的。 　　 <br />
        <br />
        第七十三条　行政机关工作人员办理行政许可、实施监督检查，索取或者收受他人财物或者谋取其他利益，构成犯罪的，依法追究刑事责任；尚不构成犯罪的，依法给予行政处分。
        　　 <br />
        <br />
        第七十四条　行政机关实施行政许可，有下列情形之一的，由其上级行政机关或者监察机关责令改正，对直接负责的主管人员和其他直接责任人员依法给予行政处分；构成犯罪的，依法追究刑事责任：
        　　 <br />
        <br />
        （一）对不符合法定条件的申请人准予行政许可或者超越法定职权作出准予行政许可决定的；
        　　 <br />
        <br />
        （二）对符合法定条件的申请人不予行政许可或者不在法定期限内作出准予行政许可决定的；
        　　 <br />
        <br />
        （三）依法应当根据招标、拍卖结果或者考试成绩择优作出准予行政许可决定，未经招标、拍卖或者考试，或者不根据招标、拍卖结果或者考试成绩择优作出准予行政许可决定的。
        　　 <br />
        <br />
        第七十五条　行政机关实施行政许可，擅自收费或者不按照法定项目和标准收费的，由其上级行政机关或者监察机关责令退还非法收取的费用；对直接负责的主管人员和其他直接责任人员依法给予行政处分。
        　　截留、挪用、私分或者变相私分实施行政许可依法收取的费用的，予以追缴；对直接负责的主管人员和其他直接责任人员依法给予行政处分；构成犯罪的，依法追究刑事责任。
        　　 <br />
        <br />
        第七十六条　行政机关违法实施行政许可，给当事人的合法权益造成损害的，应当依照国家赔偿法的规定给予赔偿。
        　　 <br />
        <br />
        第七十七条　行政机关不依法履行监督职责或者监督不力，造成严重后果的，由其上级行政机关或者监察机关责令改正，对直接负责的主管人员和其他直接责任人员依法给予行政处分；构成犯罪的，依法追究刑事责任。
        　　 <br />
        <br />
        第七十八条　行政许可申请人隐瞒有关情况或者提供虚假材料申请行政许可的，行政机关不予受理或者不予行政许可，并给予警告；行政许可申请属于直接关系公共安全、人身健康、生命财产安全事项的，申请人在一年内不得再次申请该行政许可。
        　　 <br />
        <br />
        第七十九条　被许可人以欺骗、贿赂等不正当手段取得行政许可的，行政机关应当依法给予行政处罚；取得的行政许可属于直接关系公共安全、人身健康、生命财产安全事项的，申请人在三年内不得再次申请该行政许可；构成犯罪的，依法追究刑事责任。
        　　 <br />
        <br />
        第八十条　被许可人有下列行为之一的，行政机关应当依法给予行政处罚；构成犯罪的，依法追究刑事责任：
        　　 <br />
        <br />
        （一）涂改、倒卖、出租、出借行政许可证件，或者以其他形式非法转让行政许可的；
        　　 <br />
        <br />
        （二）超越行政许可范围进行活动的； 　　 <br />
        <br />
        （三）向负责监督检查的行政机关隐瞒有关情况、提供虚假材料或者拒绝提供反映其活动情况的真实材料的；
        　　 <br />
        <br />
        （四）法律、法规、规章规定的其他违法行为。 　　 <br />
        <br />
        第八十一条　公民、法人或者其他组织未经行政许可，擅自从事依法应当取得行政许可的活动的，行政机关应当依法采取措施予以制止，并依法给予行政处罚；构成犯罪的，依法追究刑事责任。
        <br />
        <br />
        第八章　附　　则 　　 <br />
        <br />
        第八十二条　本法规定的行政机关实施行政许可的期限以工作日计算，不含法定节假日。
        　　 <br />
        <br />
        第八十三条　本法自2004年7月1日起施行。
        　　本法施行前有关行政许可的规定，制定机关应当依照本法规定予以清理；不符合本法规定的，自本法施行之日起停止执行。
      </div>

      <br />
    </div>
  );
};
